import { useWatch } from 'react-hook-form';
import FormSchemaParser from '@/components/Common/FormSchemaParser';

interface CureMdFormProps {
  namePrefix: string;
  control: any;
  disabled?: boolean;
  configFields: any;
  spacing: string;
  submitForm?: any;
  publicForm?: boolean;
}

const resourcesEnabled = (value: unknown) => value === true || value === 'true' || value === 1 || value === '1';

const CureMdForm = ({
  namePrefix,
  control,
  disabled,
  configFields,
  spacing,
  submitForm,
  publicForm = false
}: CureMdFormProps) => {
  const useResources = useWatch({ control, name: `${namePrefix}.use_resources` });
  const showResourceMapping = resourcesEnabled(useResources);

  const fields = (configFields || []).filter((field: { key?: string }) => {
    if (field.key === 'provider_id') return !showResourceMapping;
    if (field.key === 'resource_mappings') return showResourceMapping;
    return true;
  });

  return (
    <FormSchemaParser
      publicForm={publicForm}
      disabled={disabled}
      fields={fields}
      control={control}
      namePrefix={namePrefix}
      gridSize={12}
      spacing={spacing}
      submitForm={submitForm}
    />
  );
};

export default CureMdForm;
